import React from 'react';
import Input from '../../../components/ui/Input';

const CustomerInfoSection = ({ formData, errors, onChange }) => {
  return (
    <div className="rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl">
      <h2 className="mb-6 text-xl font-bold text-foreground">고객 정보</h2>
      <div className="space-y-4">
        <Input
          label="이름"
          type="text"
          name="customerName"
          placeholder="홍길동"
          value={formData?.customerName}
          onChange={onChange}
          error={errors?.customerName}
          required
          className="bg-muted"
        />
        <Input
          label="전화번호"
          type="tel"
          name="customerPhone"
          placeholder="01012345678"
          value={formData?.customerPhone}
          onChange={onChange}
          error={errors?.customerPhone}
          required
          className="bg-muted"
        />
        <Input
          label="주소"
          type="text"
          name="customerAddress"
          placeholder="서울시 강남구 테헤란로 123 / 공통현관 비밀번호 #1234"
          value={formData?.customerAddress}
          onChange={onChange}
          error={errors?.customerAddress}
          required
          className="bg-muted"
        />
      </div>
    </div>
  );
};

export default CustomerInfoSection;